import React from 'react'
import SettingsMiscellaneousForm from '../components/setting/settingsMiscellaneousForm'

const SettingsMiscellaneous = () => {
    return (
        <>
            <SettingsMiscellaneousForm />
        </>
    )
}

export default SettingsMiscellaneous